import { Card } from '@ps/sports-ui-component-library';
import { ResolverTag } from '@ps/web-core-enums';
import { Translation, useResolver } from '@ps/web-shared-components';
import React from 'react';

import { TXTWCL_In_Play_information_subject_to_ELL } from './LiveDataWarning.messages.json';
import styles from './LiveDataWarning.scss';

const LiveDataWarning = () => {
  const horseRacingRulesHref = useResolver(ResolverTag.HelpGameSportsRules);

  return (
    <Card padded className={styles.card}>
      <Translation
        {...TXTWCL_In_Play_information_subject_to_ELL}
        values={{
          a: (content: string) => (
            <a target="_blank" href={horseRacingRulesHref} rel="noreferrer" className={styles.link}>
              {content}
            </a>
          )
        }}
      />
    </Card>
  );
};

export default LiveDataWarning;
